// src/data/clusterDefinitions.js

export const CURRENCY_GROUPS = {
  MAJORS: ["USD", "EUR", "JPY", "GBP", "AUD", "CAD", "CHF", "NZD"],
  BRICS: [
    "Brazilian Real", "Real", "BRL",
    "Russian Ruble", "Ruble", "RUB",
    "Indian Rupee", "Rupee", "INR",
    "Chinese Yuan", "Yuan", "CNY",
    "South African Rand", "Rand", "ZAR"
  ],
  G7: [
    "US Dollar", "Euro", "Japanese Yen", "British Pound", "Canadian Dollar", "Australian Dollar"
  ],
  MERCOSUL: [
    "Brazilian Real", "Argentine Peso", "Uruguayan Peso", "Paraguayan Guarani", "Bolivian Boliviano"
  ],
  ASEAN: [
    "Singapore Dollar", "Thai Baht", "Malaysian Ringgit", "Indonesian Rupiah", 
    "Philippine Peso", "Vietnamese Dong"
  ],
  GCC: [ // Gulf Cooperation Council
    "Saudi Riyal", "Qatari Riyal", "UAE Dirham", "Kuwaiti Dinar", "Omani Rial", "Bahraini Dinar"
  ]
};

export const INDEX_GROUPS = {
  AMERICAS: [
    "S&P 500", "Dow Jones", "Nasdaq", "NYSE", "S&P/TSX", // North
    "Ibovespa", "Merval", "IPSA", "Colcap" // South/Latam
  ],
  EUROPE: [
    "DAX", "CAC 40", "FTSE 100", "Euro Stoxx", "IBEX 35", "AEX", "SMI", "MIB"
  ],
  ASIA: [
    "Nikkei 225", "Hang Seng", "Shanghai Composite", "Nifty 50", "KOSPI", "Taiwan Weighted", "STI"
  ],
  BRICS: [
    "Ibovespa", "MOEX", "Nifty", "Shanghai", "Hang Seng", "JSE Top 40"
  ],
  TECH_CRYPTO: [
    "Nasdaq", "Bitcoin", "Ethereum", "Solana", "Coinbase", "MicroStrategy" 
  ]
};